import React from "react"

type Props = {
  className?: string
}

const ProductIcon = ({ className }: Props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.8334 16.667V3.33366C15.8334 2.41318 15.0872 1.66699 14.1667 1.66699H8.62171C8.31832 1.66699 8.02068 1.74981 7.76089 1.90651L7.63401 1.98303C7.37422 2.13973 7.07658 2.22255 6.77319 2.22255H5.83341C4.91294 2.22255 4.16675 2.96874 4.16675 3.88921V16.667C4.16675 17.5875 4.91294 18.3337 5.83342 18.3337H14.1667C15.0872 18.3337 15.8334 17.5875 15.8334 16.667Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M12.9167 5H7.08341C6.8533 5 6.66675 5.18655 6.66675 5.41667V15.4167C6.66675 15.6468 6.8533 15.8333 7.08341 15.8333H12.9167C13.1469 15.8333 13.3334 15.6468 13.3334 15.4167V5.41667C13.3334 5.18655 13.1469 5 12.9167 5Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default ProductIcon
